import styled from 'styled-components';

import { getPurpurSpacing, purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

export const List = styled.ul`
    display: grid;
    gap: ${getPurpurSpacing('300')};
    ${purpurMedia('sm')`--columns: 1;`};
    ${purpurMedia('md')`--columns: 2;`};
    ${purpurMedia('lg')`--columns: 3;`};
    grid-template-columns: repeat(var(--columns), 1fr);

    margin: ${getPurpurSpacing('400')} 0 ${getPurpurSpacing('600')};
    padding: unset;
    list-style-type: none;
`;
